import React from 'react';
import styled from 'styled-components';

import SelectSocialIcon from '../../Img/SocialIcons';

const SocialLink = styled.a`
  display: flex;
  cursor: pointer;
  > svg {
    width: 60%;
    height: 60%;
    margin: auto;
  }
  :hover {
    opacity: 0.7;
  }
`;

const SocialLinkContainer = styled.div`
  height: 60px;
  width: 60px;
  border-radius: 30px;
  background-color: #6bb951;
  position: relative;
  display: flex;
  transition: transform 0.8s;
`;

const FloatingButtonContainer = styled.div`
  height: 0px;
  width: 0px;
  position: fixed;
  top: calc(100% - 90px);
  left: calc(100% - 90px);
  z-index: 10;
  transition: opacity 0.3s;
`;

export class FloatingButton extends React.Component {
  state = {
    showButton: false,
  };
  checkScroll = () => {
    const showButton =
      window.pageYOffset > document.getElementById('header').offsetTop;
    this.setState({
      showButton,
    });
  };
  componentDidMount = () => {
    window.addEventListener('scroll', this.checkScroll);
  };
  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.checkScroll);
  };

  render() {
    const { showButton } = this.state;
    return (
      <FloatingButtonContainer
        style={{
          opacity: showButton ? 1 : 0,
        }}
      >
        <SocialLinkContainer
          style={{
            transform: showButton ? 'scale(1, 1)' : 'scale(0, 0)',
          }}
        >
          <SocialLink
            href={this.props.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <SelectSocialIcon iconName={this.props.icon} />
          </SocialLink>
        </SocialLinkContainer>
      </FloatingButtonContainer>
    );
  }
}

export default FloatingButton;



// WEBPACK FOOTER //
// ./src/components/UI/Buttons/FloatingButton/index.jsx